function makeSelectCurrentTaskEntry(component) {
  return entry => {
    const currentTaskIdFromEntry = entry?.activeTaskId;
    if (currentTaskIdFromEntry && component.tasks.some(it => it.id === currentTaskIdFromEntry)) {
      return entry.tasks[currentTaskIdFromEntry];
    }
    return entry?.tasks[component.tasks[0]?.id ?? ""];
  };
}

export { makeSelectCurrentTaskEntry };
//# sourceMappingURL=entry.get-current-task.js.map
